import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type {
  PaginationSearchRequest,
  PaginationSearchResult,
} from "share-components/mui-wrap/auto-complete/x-auto-complete-with-pagination";

export const searchOrderPONumberOptions = async (keyword: string) => {
  const res = await orderBusiness.searchOrders(keyword);
  return mapToDistinctOptionItems(res.items, (x) => x.poNumber);
};

export const searchOrderPONumberOptionsWithPagination = async (
  keyword: string,
  request: PaginationSearchRequest,
): Promise<PaginationSearchResult> => {
  const res = await orderBusiness.getLists({
    filter: keyword,
    maxResultCount: request.pageSize,
    skipCount: request.pageIndex * request.pageSize,
    sorting: "",
    customerId: "",
  });

  return {
    items: mapToDistinctOptionItems(res.items, (x) => x.poNumber),
    totalCount: res.totalCount,
  };
};
